import React, { Component } from "react";
import {
  Header,
  Icon,
  Loader
} from "semantic-ui-react";

import Firebase from './Firebase';
import BookDisplay from './BookDisplay';
import ErrorDisplay from './ErrorDisplay';

const style = {
  mainSeg: {
    paddingTop: '15em',
    paddingBottom: '15em',
    textAlign: 'center'
  }
};

export default class AdminBook extends Component {
  constructor(props){
    super(props);
    this.state = {
      pictures: null,
      bookData: null,
      errorMsg: null
    };
  }

  componentDidMount() {
    var db = Firebase.getFirestore();
    var storage = Firebase.getStorage();

    // pull the book data
    db.collection("books").doc(this.props.match.params.id).get()
      .then((doc) => {
        if (doc.exists) {
            this.setState({bookData : doc.data()});
        } else {
            this.setState({errorMsg : "404: No such book!"});
        }
      })
      .catch((error) => {
        this.setState({errorMsg : error.message });
      });

    // pull the pictures
    db.collection("books").doc(this.props.match.params.id).collection("pictures")
      .get()
      .then((querySnapshot) => {
          var newPictures = [];
          var taskList = [];
          querySnapshot.forEach((doc) => {
              var data = doc.data();

              // transform the picture url
              var picRef = storage.refFromURL(data.picture);
              taskList.push(
                picRef.getDownloadURL().then((downloadURL) => {
                  data.picture = downloadURL;
                  newPictures[doc.id] = data;
                }).catch((err) => {
                  this.setState({errorMsg : "error getting a picture : " + err.message});
                }));
          });

          Promise.all(taskList).then((values) => {
            this.setState({pictures : newPictures});
          });
      })
      .catch((error) => {
          this.setState({errorMsg : "error getting pictures : " + error.message});
      });

  }

  render() {
    if(this.state.errorMsg) {
      return <ErrorDisplay message={this.state.errorMsg} />;
    } else if(this.state.bookData && this.state.pictures) {
      return (
        <BookDisplay
          name={this.state.bookData.name}
          email={this.state.bookData.email}
          telephone={this.state.bookData.telephone}
          pictures={this.state.pictures}
          />
      );
    } else {
      return (
        <div style={style.mainSeg}>
          <Loader active inline='centered' size='large'>Loading..</Loader>
        </div>
      );
    }
  }
}
